// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a968eafa","453":"9bad9f5a","732":"b95cb4c8","977":"42d4a2b1"}[chunkId] + ".chunk.js";
};